import React from 'react';
import { Modal,Button} from 'rsuite';
//import axios from 'axios';
export default class TargetPanel extends React.Component {
    constructor(props) {
      super(props);
    //   this.state = {
    //     text : []
    //   }
    //   axios.get('/configs/targetPanelConfig.json')
    //   .then(response=>{
    //     this.setState({
    //         text:response.data.text,
    //     })
    //     console.log(this.state.text);
    //   })
    }
    // outputText=()=>{
    //     this.state.text.map((e,index)=>{
    //         return(
    //             <div key={index}>
    //                 {e}<br/>
    //             </div>
    //         )
    //     })
    // }
    render () {
        return(
            <Modal show={this.props.showtarget} onHide={this.props.targetclose}  overflow>
            <Modal.Header>
              <Modal.Title>系统说明</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            本系统通过虚拟仿真的方式，采用计算机三维技术模拟出虚拟的地质环境、 真实的仪器操作界面和仪器操作步骤。通过仿真与人机交互互动，帮助用户掌握野外电法勘探基本原理、步骤及仪器操作过程。
            <br/>
            主要功能及步骤：<br/>
            （1）工程场景（地质模型）选择<br/>
            （2）测线布设（绘制）<br/>
            （3）电极设置（电极距、电极数）<br/>
            （4）仪器连线（电源、转换机、主机连接）<br/>
            （5）仪器测量参数设置<br/>
            （6）电极转换原理（测量动画播放）<br/>
            （7）测量结果显示<br/>
            （8）结果下载及处理（反演）<br/>
            （9）报告编制<br/>
            {/* <this.outputText/> */}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.props.targetclose}  appearance="primary">
                知道了
              </Button>
            </Modal.Footer>
        </Modal>
        );
    }
}